import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const optimizeShippingCopyPLPSelector = createSelector(testTargetOffersSelector, offers => offers.optimizeShippingCopyPLP || Empty.Object);

export { optimizeShippingCopyPLPSelector };
